import React from 'react';
import { withCookies } from 'react-cookie';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DesktopLoggedPage from './DesktopLoggedPage';
import DesktopNonLoggedPage from './DesktopNonLoggedPage';
import MenuSettingsDialog from './parts/MenuSettingsDialog';
import MenuPasswordDialog from './parts/MenuPasswordDialog';
import DesktopDrawer from './parts/DesktopDrawer';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    color: '#000',
    backgroundColor: '#fff',
    position: 'fixed',
  },
  appBarWithDrawer: {
    width: 'calc(100% - 240px)',
    boxShadow: 'none',
    backgroundColor: '#2096f3',
    color: '#fff',
    marginLeft: 240,
    left: 0,
  },
  loadingWrapper: {
    padding: 24,
    textAlign: 'center',
  },
  pageWrapper: {
    padding: 24,
  },
  drawerWrapper: {
    width: 240,
    flexShrink: 0,
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    marginTop: 64,
    overflowX: 'hidden',
  },
});

class DesktopApp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuAnchorEl: null,

      settingsMenuIsOpen: false,
      settingsMenuHash: '',

      passwordMenuIsOpen: false,
      passwordMenuHash: '',
    };

    this.onSettingsClick = this.onSettingsClick.bind(this);
    this.onAccountSettingsClick = this.onAccountSettingsClick.bind(this);
    this.onPasswordSettingsClick = this.onPasswordSettingsClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
  }

  onSettingsClick(event) {
    this.setState({
      menuAnchorEl: event.currentTarget,
    });
  }

  onAccountSettingsClick(event) {
    this.setState({
      menuAnchorEl: null,
      settingsMenuIsOpen: true,
      settingsMenuHash: `${(new Date()).getTime()}`, // Hack for the redrawing,
    });
  }

  onPasswordSettingsClick(event) {
    this.setState({
      menuAnchorEl: null,
      passwordMenuIsOpen: true,
      passwordMenuHash: `${(new Date()).getTime()}`, // Hack for the redrawing,
    });
  }

  onMenuClose(event) {
    this.setState({
      menuAnchorEl: null,
    });
  }

  render() {
    const {
      menuAnchorEl,
      settingsMenuIsOpen,
      settingsMenuHash,
      passwordMenuIsOpen,
      passwordMenuHash,
    } = this.state;
    const {
      t,
      classes,
      isLoggedIn,
      view,
    } = this.props;

    const logoUrl = 'https://195ec04504ea0272771e-7c2c6dacbab7a2b2d574b53c70c1fe31.ssl.cf3.rackcdn.com/6.1.31/img/logo/CC_logo.png';

    const appBarClassName = isLoggedIn
      ? `${classes.appBar} ${classes.appBarWithDrawer}`
      : `${classes.appBar}`;

    return (
      <div id="desktop-app" className={classes.root}>
        {isLoggedIn && (
          <div className={classes.drawerWrapper}>
            <DesktopDrawer useSuspense={false} />
          </div>
        )}
        <AppBar
          position="static"
          className={appBarClassName}
        >
          <Toolbar>
            {!isLoggedIn && (
              <img src={logoUrl} alt="Logo" />
            )}
            <Typography
              variant="h6"
              color="inherit"
              className={classes.grow}
            />
            {isLoggedIn && (
              <div>
                {appType === 'parent'
                  && (
                  <span>
                    <Button
                      color="inherit"
                      onClick={this.onSettingsClick}
                      className="settings-button"
                    >
                      {t('Settings')}
                    </Button>
                    <Menu
                      anchorEl={menuAnchorEl}
                      open={Boolean(menuAnchorEl)}
                      onClose={this.onMenuClose}
                    >
                      <MenuItem onClick={this.onAccountSettingsClick}>
                        {t('Account settings')}
                      </MenuItem>
                      <MenuItem onClick={this.onPasswordSettingsClick}>
                        {t('Password settings')}
                      </MenuItem>
                    </Menu>
                  </span>
                )}
                {appType === 'student' && (
                  <Button
                    color="inherit"
                    onClick={() => {
                      this.props.onMyCodeClick();
                    }}
                    className="my-code-button"
                  >
                    {t('My code')}
                  </Button>
                )}
                <Button
                  color="inherit"
                  onClick={() => {
                    this.props.onLogoutClick();
                  }}
                  className="logout-button"
                >
                  {t('Logout')}
                </Button>
              </div>
              )
            }
          </Toolbar>
        </AppBar>
        <div className={classes.content}>
          {view === 'loading' && (
            <div className={classes.loadingWrapper}>
              <CircularProgress />
            </div>
          )}
          {(view === 'dashboard' || view === 'pupil') && (
            <div>
              <DesktopLoggedPage useSuspense={false} />
            </div>
          )}
          {view === 'non_logged' && (
            <div>
              <DesktopNonLoggedPage useSuspense={false} />
            </div>
          )}
        </div>
        <MenuSettingsDialog
          isOpen={settingsMenuIsOpen}
          hash={settingsMenuHash}
          useSuspense={false}
        />
        <MenuPasswordDialog
          isOpen={passwordMenuIsOpen}
          hash={passwordMenuHash}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(withCookies(DesktopApp)));
